import { useLanguage } from "@/contexts/LanguageContext";

const Terms = () => {
  const { t } = useLanguage();
  
  return (
      <div className="py-16">
        <section className="py-20 bg-muted">
          <div className="container mx-auto px-4">
            <div className="max-w-3xl mx-auto text-center">
              <h1 className="text-4xl md:text-5xl font-bold text-foreground mb-6">
                {t('terms.title')}
              </h1>
            </div>
          </div>
        </section>
  
        <section className="py-16">
          <div className="container mx-auto px-4">
            <div className="max-w-3xl mx-auto">
              <div className="bg-card p-8 rounded-2xl shadow-lg space-y-6">
                <div>
                  <h2 className="text-2xl font-bold text-foreground mb-4">{t('terms.acceptTitle')}</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    {t('terms.acceptDesc')}
                  </p>
                </div>
  
                <div>
                  <h2 className="text-2xl font-bold text-foreground mb-4">{t('terms.registrationTitle')}</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    {t('terms.registrationDesc')}
                  </p>
                </div>
  
                <div>
                  <h2 className="text-2xl font-bold text-foreground mb-4">{t('terms.usageTitle')}</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    {t('terms.usageDesc')}
                  </p>
                </div>
  
                <div>
                  <h2 className="text-2xl font-bold text-foreground mb-4">{t('terms.offersTitle')}</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    {t('terms.offersDesc')}
                  </p>
                </div>
  
                <div>
                  <h2 className="text-2xl font-bold text-foreground mb-4">{t('terms.disclaimerTitle')}</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    {t('terms.disclaimerDesc')}
                  </p>
                </div>
  
                <div>
                  <h2 className="text-2xl font-bold text-foreground mb-4">{t('terms.modificationsTitle')}</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    {t('terms.modificationsDesc')}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  };
  
  export default Terms;
  